export default "__VITE_ASSET__BzfHyWgX__"